<template>
    <div id="app-vue">
      <component :is="layout"></component>
    </div>
</template>
<script>
const requireContext = require.context('./furnishweb/layouts', false, /.*\.vue$/);
const layouts = requireContext.keys().map(file =>
    [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)]
  )
  .reduce((components, [name, component]) => {
    components[name] = component.default || component
    return components
  }, {})

import {mapGetters}  from 'vuex'
export default {
    components : {
      ...layouts
    },
    data: ()=> ({
     /*  layout : 'authenticated' */
    }),
    mounted() {

    },
    methods : {
      
    },
    computed: {
       ...mapGetters('AppModule',[
            'layout'
        ])
    },

   

}
</script>\